import React from 'react';
import DocumentReader from './DocumentReader';
import { documentTitle, documentSlug, parts } from './content/expressionIdeasReference';

export default function ExpressionIdeasReference() {
  return (
    <DocumentReader
      documentId={documentSlug}
      title={documentTitle}
      intro="Quick-lookup lists for Expression of Ideas — transition word categories and the rhetorical synthesis checklist."
      parts={parts}
    />
  );
}
